import React from 'react';
import { createRoot } from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { ConfigProvider } from 'antd';
import {
  BrowserRouter as Router
} from 'react-router-dom';
import App from './components/App';
import antdTheme from './theme';
import './i18n/config';
import './assets/css/tailwind.css';
import './assets/css/main.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <ConfigProvider theme={antdTheme}>
    <Router>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </Router>
  </ConfigProvider>
);
